import { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import SchedulingPicker from "shared/components/Form/SchedulingPicker";
import { useBroadcastDetails } from "../../context";

const Scheduling: FC = () => {
  const {
    scheduledAt,
    setScheduledAt,
    isSchedulingEnabled,
    setIsSchedulingEnabled,
    isReadOnlyMode,
  } = useBroadcastDetails();

  return (
    <ContentSection>
      <SchedulingPicker
        scheduledStartAt={scheduledAt ?? ""}
        onScheduledStartAtChange={setScheduledAt}
        isSchedulingEnabled={isSchedulingEnabled}
        onSchedulingEnabledChange={setIsSchedulingEnabled}
        disabled={isReadOnlyMode}
      />
    </ContentSection>
  );
};

export default Scheduling;
